module.exports = __webpack_public_path__ + "img/art-brushes.69dab3a0.jpeg";